import { supportedVideoFormats, uploadSizeLimitInBytes } from "./constants";

const fileIsSupportedImage = fileType => /image\/[a-z]/.test(fileType);

const fileIsSupportedVideo = fileType => supportedVideoFormats.indexOf(fileType) > -1;

export const getSizeLimitInMbs = () => uploadSizeLimitInBytes / 1024 / 1024;

export const checkIfFileTypeIsSupported = fileType => fileIsSupportedImage(fileType) || fileIsSupportedVideo(fileType);

export const checkIfFileSizeIsSupported = fileSize => fileSize <= uploadSizeLimitInBytes;

export const getFileType = fileMIMEType => {
  if (fileIsSupportedImage(fileMIMEType)) {
    return "image";
  } else if (fileIsSupportedVideo(fileMIMEType)) {
    return "video";
  }
  return "Unknown";
};



// WEBPACK FOOTER //
// ./src/scenes/NewCase/util.js